module.exports = __webpack_public_path__ + "static/media/clinical-allergy-bg.2b498144.png";